document.addEventListener('DOMContentLoaded', function () {
  const items = document.querySelectorAll('.zl-mobile-item');

  items.forEach(item => {
    const toggle = item.querySelector('.zl-mobile-toggle');
    if(toggle){
      toggle.addEventListener('click', () => {
        item.classList.toggle('open');
      });
    }
  });
});